import { Flex } from "@similarweb/ui-components/foundations";

import LoaderGradient from "app/pages/sales-intelligence/pages/company-analysis/components/shared/Loader/LoaderGradient";
import { StyledVerticalLine } from "app/pages/sales-intelligence/pages/company-analysis/containers/overview/CompanyData/styles";

export const Skeleton = () => {
    const renderGroup = (maxWidth: number, itemsWidth: [number, number]) => (
        <Flex
            gap="32px 40px"
            flexWrap="wrap"
            maxWidth={`${maxWidth}px`}
        >
            <LoaderGradient
                width={itemsWidth[0]}
                height={44}
            />
            <LoaderGradient
                width={itemsWidth[1]}
                height={44}
            />
            <LoaderGradient
                width={itemsWidth[0]}
                height={44}
            />
            <LoaderGradient
                width={itemsWidth[1]}
                height={44}
            />
        </Flex>
    );

    return (
        <Flex
            padding="24px 28px"
            justifyContent="space-between"
            flexWrap="wrap"
            gap="40px 0px"
        >
            {renderGroup(274, [118, 116])}
            <StyledVerticalLine />
            {renderGroup(262, [118, 104])}
            <StyledVerticalLine />
            {renderGroup(319, [118, 161])}
        </Flex>
    );
};
